'use strict';

import template from './trip_offer_accept_modal.html';

export default {
  bindings: {
    done: '&',
  },
  template: template,
  controller: function($timeout, $scope, trips, userModel) {
    'ngInject';

    this.userModel = userModel;

    this.trips = trips;
    this.conversation = this.trips.accept.conversation;
    this.message = this.trips.accept.message;
    this.message.data.responseMessage = {};
    this.message.data.responseMessage.content = '';

    this.isProcessing = false;
    this.acceptOffer = function () {
      // TODO: hmmm... should process longer
      this.isProcessing = true;
      this.isProcessing = false;
      this.done();
    };

    // TODO: refactor (see duplicate in booking form)
    $timeout(() => {
      $scope.$broadcast('elastic:adjust');
    });
  },
};



// WEBPACK FOOTER //
// ./app/src/components/conversations/trip_offer_accept_modal/trip_offer_accept_modal.js